import React from "react";
import "../App.css";
import { Trans, withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { Paginator } from "primereact/paginator";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import moment from "moment";
import {
  getEquipmentReportOptions,
  getEquipmentServiceHistoryCost,
  getEquipmentServiceOverAllBudget,
} from "../Actions/ShipEquipmentDetailsAPI";
import axios from "axios";
import API from "../helpers/api";
import FileSaver from "file-saver";
import { toast } from "react-toastify";
import { getContractDeatil } from "../Actions/ContractMgmtAPI";

class ServiceBudgetHistory extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // contractId: 0,
      // budgetData: {
      //   "fzm": [
      //     {
      //       "zone": "A",
      //       "cost": 1180
      //     },
      //     {
      //       "zone": "B",
      //       "cost": 1180
      //     },
      //     {
      //       "zone": "C",
      //       "cost": 1180
      //     },
      //     {
      //       "zone": "D",
      //       "cost": 1180
      //     }
      //   ],
      //   "ifs": {
      //     "basic": 1920,
      //     "std": 3920,
      //     "premium": 4223
      //   },
      //   "currentPlan": "A/B/C/D/E/BASIC/STD/PREMIUM",
      //   "currentContract": "FZM/IFS",
      //   "totalExpense": [
      //     {
      //       "zone": "A",
      //       "value": 1112
      //     },
      //     {
      //       "zone": "B",
      //       "value": 0
      //     },
      //     {
      //       "zone": "C",
      //       "value": 350
      //     },
      //     {
      //       "zone": "D",
      //       "value": 1005
      //     }
      //   ]
      // },
      // zoneLookup: [
      //   {
      //     id: 1,
      //     value: "A"
      //   },
      //   {
      //     id: 2,
      //     value: "B"
      //   },
      //   {
      //     id: 3,
      //     value: "C"
      //   },
      //   {
      //     id: 3,
      //     value: "D"
      //   }
      // ],
      // budgetFZM: {},
      timeLine: [
        { text: "Annual", div: 1 },
        { text: "Half Yearly", div: 2 },
        { text: "Quaterly", div: 4 },
        { text: "Monthly", div: 12 },
      ],
      budgetDataIFS: [{ text: "Basic" }, { text: "STD" }, { text: "Premium" }],
      // currentPlan: "",
      // totalExp: {},
      // reportData: {

      // }
    };
  }

  componentDidMount() {
    const { match, dispatch } = this.props;
    const { params } = match;
    const { contractId, shipId } = params;

    this.setState(
      {
        contractId: contractId,
      },
      () => {
        dispatch(getEquipmentServiceHistoryCost(this.state.contractId));
        dispatch(getEquipmentServiceOverAllBudget(this.state.contractId));
        dispatch(getContractDeatil(this.state.contractId));
        dispatch(getEquipmentReportOptions(shipId));
      }
    );
  }

  // static getDerivedStateFromProps(nextProps, prevState) {
  //   const { shipEquipmentServiceBudget } = nextProps;
  //   if (shipEquipmentServiceBudget) {
  //     /* process overall budget data */
  //     /*
  //     {
  //       "zone": "A",
  //       "value": 1180
  //     }
  //       to
  //     A: {
  //       "annual": 1180,
  //       "halfYearly": 590,
  //       "quaterly": 295,
  //       "monthly": 98.33333333333333
  //     }
  //     */
  //     let fzm = {};
  //     let ifs = {};
  //     shipEquipmentServiceBudget.fzm.forEach(x => {
  //       fzm[x.zone] = {
  //         "Annual": x.cost,
  //         "Half Yearly": x.cost / 2,
  //         "Quaterly": x.cost / 4,
  //         "Monthly": x.cost / 12
  //       }
  //     });
  //     /*
  //       {
  //         "basic": 1920,
  //         "std": 3920,
  //         "premium": 4223
  //       }
  //       to
  //       basic: {
  //         "annual": 1180,
  //         "halfYearly": 590,
  //         "quaterly": 295,
  //         "monthly": 98.33333333333333
  //       }
  //      */
  //     Object.keys(shipEquipmentServiceBudget.ifs).forEach(i => {
  //       ifs[i] = {
  //         "Annual": shipEquipmentServiceBudget.ifs[i],
  //         "Half Yearly": shipEquipmentServiceBudget.ifs[i] / 2,
  //         "Quaterly": shipEquipmentServiceBudget.ifs[i] / 4,
  //         "Monthly": shipEquipmentServiceBudget.ifs[i] / 12
  //       }
  //     });
  //     /*
  //       {
  //         "zone": "A",
  //         "value": 1112
  //       }

  //       to

  //       {
  //         A: 1112
  //       }
  //     */
  //     let totalExp = {};
  //     shipEquipmentServiceBudget.totalExpense.forEach(element => {
  //       totalExp[element.zone] = element.value;
  //     });
  //     return {
  //       budgetFZM: fzm,
  //       budgetIFS: ifs,
  //       currentPlan: shipEquipmentServiceBudget.currentPlan,
  //       totalExp: totalExp
  //     };
  //   }
  // }

  handleCompanyInputChange = (e, str) => {
    if (str === "fleetmanager") {
      this.setState({
        fleetmanager: e.target.value,
        superintendent: "",
      });
    } else {
      this.setState({
        fleetmanager: "",
        superintendent: e.target.value,
      });
    }
  };

  clearFields = () => {
    this.setState({
      fleetmanager: "",
      superintendent: "",
    });
  };

  exportReport = () => {
    const { dispatch, match } = this.props;
    let email =
      this.state.fleetmanager !== ""
        ? this.state.fleetmanager
        : this.state.superintendent;
    let url = `${API.budgetReport}?email=${email}`;
    axios
      .get(url, { responseType: "blob" })
      .then((response) => {
        let blob = "";
        let FileName =
          "BudgetReport" + "_" + moment().format("DD MM YYYY LT") + ".pdf";
        blob = new Blob([response.data], { type: response.data.type });
        FileSaver.saveAs(blob, FileName);
        this.clearFields();
        toast.success("Downloaded successfully", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      })
      .catch((error) => {
        console.log(error);
        dispatch({
          type: "AttchmentUploadedFailure",
          error: "ERROR",
        });
      });
  };

  groupServicesByType(data) {
    const value = data.map((item) => {
      const groupedServices = item.services.reduce((acc, service) => {
        if (!acc[service.serviceType]) {
          acc[service.serviceType] = [];
        }
        acc[service.serviceType].push(service);
        return acc;
      }, {});

      const availableservices = Object.keys(groupedServices).map(
        (serviceType) => {
          const services = groupedServices[serviceType];
          const latestService = services.reduce((latest, current) => {
            const latestDate = new Date(
              latest.serviceDueDate.split("-").reverse().join("-")
            );
            const currentDate = new Date(
              current.serviceDueDate.split("-").reverse().join("-")
            );
            return latestDate < currentDate ? latest : current;
          });

          return {
            serviceType,
            services,
            latestServiceDueDate: latestService.serviceDueDate,
            dueInfo: {
              overDue: latestService.overDue,
              in10Days: latestService.in10Days,
              in30Days: latestService.in30Days,
              in60Days: latestService.in60Days,
              in90Days: latestService.in90Days,
            },
          };
        }
      );

      return {
        ...item,
        availableservices,
      };
    });
    console.log(value);
    return value;
  }

  renderView = (overDue, in10Days, in30Days, in60Days, in90Days) => {
    let message = null;

    if (overDue) message = "Service overdue";
    else if (in10Days) message = "Service due in 10 days";
    else if (in30Days) message = "Service due in 30 days";
    else if (in60Days) message = "Service due in 60 days";
    else if (in90Days) message = "Service due in 90 days";
    return message ? (
      <Popover>
        <Popover.Content>
          <label style={{ padding: "0px 0px" }}>{message}</label>
        </Popover.Content>
      </Popover>
    ) : (
      <div></div> // Fallback: empty div to avoid returning null
    );
  };

  render() {
    const {
      t,
      shipEquipmentServiceHistoryBudget,
      shipUsersReportOptions,
      shipEquipmentServiceBudget,
      ContractDetail,
    } = this.props;
    return (
      <div className="full-height">
        <div className="pt-3">
          <div className="row mt-3">
            <div className="col-lg-12">
              <div className="panel-box">
                <div
                  className="card MM-card-header"
                  style={{ backgroundColor: "white", border: "0px" }}
                >
                  <div className="card-body">
                    <h5
                      className="card-title ml-2 mt-2 d-inline-block"
                      style={{ color: "092a51" }}
                    >
                      {t("ServiceBudgetHistory.PageTitle")}
                    </h5>
                  </div>
                </div>
                <div className="search-filter-box">
                  <div
                    className="d-flex pl-2 pb-1 font-16px flex-wrap align-items-center"
                    style={{ gap: "14px" }}
                  >
                    <div className="d-flex align-items-center text-nowrap">
                      <strong>Ship Name:</strong>
                      <span className="ml-1 ">
                        {ContractDetail?.shipName || ""}
                      </span>
                    </div>
                    <div className="d-flex align-items-center text-nowrap">
                      <strong>Contract Number:</strong>
                      <span className=" ml-1">
                        {ContractDetail?.contractNumber || ""}
                      </span>
                    </div>
                    <div className="d-flex align-items-center text-nowrap">
                      <strong>Start Date:</strong>
                      <span className=" ml-1">
                        {(ContractDetail &&
                          moment(ContractDetail.startDate).format(
                            "DD MMM YYYY"
                          )) ||
                          ""}
                      </span>
                    </div>
                    <div className="d-flex align-items-center text-nowrap">
                      <strong>End Date:</strong>
                      <span className=" ml-1">
                        {(ContractDetail &&
                          moment(ContractDetail.endDate).format(
                            "DD MMM YYYY"
                          )) ||
                          ""}
                      </span>
                    </div>
                    {/* <button
                      className="btn btn-primary element-right text-uppercase txtside-btn txtht-btn blue"
                      onClick={() => this.props.history.push("/Home/Contracts")}
                    >
                      &larr; {t("CommonText.Return")}
                    </button> */}
                    <div className="ml-auto">
                      <button
                        className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                        onClick={() =>
                          this.props.history.push("/Home/Contracts")
                        }
                      >
                        &larr; {t("CommonText.Return")}
                      </button>
                    </div>
                  </div>
                  <ul
                    className="nav nav-tabs service-nav-tabs"
                    id="noteTab"
                    role="tablist"
                  >
                    <li className="nav-item">
                      <a
                        className="nav-link active"
                        id="home-tab"
                        data-toggle="tab"
                        href="#home"
                        role="tab"
                        aria-controls="home"
                        aria-selected="true"
                      >
                        <h6 className="m-0">
                          {t(
                            "EquipmentSeviceDetailsScreen.EquipmentServiceDetailsList"
                          )}
                        </h6>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className="nav-link"
                        id="profile-tab"
                        data-toggle="tab"
                        href="#profile"
                        role="tab"
                        aria-controls="profile"
                        aria-selected="false"
                      >
                        <h6 className="m-0">
                          {t("ServiceBudgetHistory.OverallBudget")}
                        </h6>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className="nav-link"
                        id="report-tab"
                        data-toggle="tab"
                        href="#report"
                        role="tab"
                        aria-controls="report"
                        aria-selected="false"
                      >
                        <h6 className="m-0">
                          {t("ServiceBudgetHistory.Report")}
                        </h6>
                      </a>
                    </li>
                    {/* <button
                      className="btn btn-primary element-right text-uppercase txtside-btn txtht-btn blue"
                      onClick={() => this.props.history.push("/Home/Contracts")}
                    >
                      &larr; {t("CommonText.Return")}
                    </button> */}
                  </ul>
                  <div className="tab-content" id="myTabContentbudget">
                    <div
                      className="tab-pane fade show active"
                      id="home"
                      role="tabpanel"
                      aria-labelledby="home-tab"
                    >
                      <div className="">
                        <ul
                          className="nav nav-tabs service-nav-tabs align-items-end"
                          id="noteTab"
                          role="tablist"
                        >
                          <li className="nav-item">
                            <a
                              className="nav-link active"
                              id="home1-tab"
                              data-toggle="tab"
                              href="#home1"
                              role="tab"
                              aria-controls="home1"
                              aria-selected="true"
                            >
                              <h6 className="m-0">
                                {t("ContractContent.Mandate")}
                              </h6>
                            </a>
                          </li>
                          <li className="nav-item">
                            <a
                              className="nav-link"
                              id="addon-tab"
                              data-toggle="tab"
                              href="#addon"
                              role="tab"
                              aria-controls="addon"
                              aria-selected="true"
                            >
                              <h6 className="m-0">
                                {t("ServiceBudgetHistory.AddOn")}
                              </h6>
                            </a>
                          </li>
                          <li className="nav-item">
                            <a
                              className="nav-link"
                              id="contact1-tab"
                              data-toggle="tab"
                              href="#contact1"
                              role="tab"
                              aria-controls="contact1"
                              aria-selected="false"
                            >
                              <h6 className="m-0">
                                {t("ServiceBudgetHistory.Adhoc")}
                              </h6>
                            </a>
                          </li>
                          <li className="nav-item">
                            <a
                              className="nav-link"
                              id="shipstaff-tab"
                              data-toggle="tab"
                              href="#shipstaff"
                              role="tab"
                              aria-controls="shipstaff"
                              aria-selected="false"
                            >
                              <h6 className="m-0">
                                {t("TopPaneContent.ShipStaff")}
                              </h6>
                            </a>
                          </li>
                        </ul>
                        <div
                          className="tab-content"
                          id="myTabContentbudget"
                          style={{ paddingLeft: "6px" }}
                        >
                          <div
                            className="tab-pane fade show active pb-3"
                            id="home1"
                            role="tabpanel"
                            aria-labelledby="home1-tab"
                          >
                            <div className="equip-type-wrapper min-hei-54">
                              <table
                                className="table service-cost-table table-responsive border-0"
                                style={{
                                  boxShadow:
                                    " rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
                                }}
                              >
                                <thead className="">
                                  <tr>
                                    <th scope="col">
                                      {t("ServiceBudgetHistory.SNo")}
                                    </th>
                                    <th scope="col">
                                      {t("ServiceBudgetHistory.EquipmentName")}
                                    </th>
                                    <th scope="col">
                                      {t("content.Servicetype")}
                                    </th>
                                    <th scope="col">
                                      {t("ServiceBudgetHistory.ActualQty")}
                                    </th>
                                    <th scope="col">
                                      {t("ServiceBudgetHistory.duedate")}
                                    </th>
                                    {/* <th scope="col">Service Due Date</th> */}
                                    <th scope="col">
                                      {t("ServiceBudgetHistory.ServiceDate")}
                                    </th>
                                    <th scope="col">
                                      {t("ServiceBudgetHistory.QtyDone")}
                                    </th>
                                    {/* <th scope="col">{t("ServiceBudgetHistory.ServiceDate")}</th> */}
                                    <th scope="col">
                                      {t("ServiceBudgetHistory.ServicedZone")}
                                    </th>
                                    <th scope="col">
                                      {t("ServiceBudgetHistory.Cost")}
                                    </th>
                                    <th scope="col">
                                      {t("ServiceBudgetHistory.TotalCost")}
                                    </th>
                                    <th scope="col">
                                      {t("ServiceBudgetHistory.TotalQtyDone")}
                                    </th>
                                    <th scope="col">
                                      {t("ServiceBudgetHistory.JobStatus")}
                                    </th>
                                    <th scope="col">
                                      {t("ServiceBudgetHistory.CostSaving")}
                                    </th>
                                  </tr>
                                </thead>
                                {/* <tbody>
                                  {
                                    shipEquipmentServiceHistoryBudget?.contract?.length > 0 ? shipEquipmentServiceHistoryBudget?.contract.map((x, ind) => (
                                      <>
                                        <tr>
                                          <td rowspan={x.services?.length || 1} className="leftsix">{ind + 1}</td>
                                          <td rowspan={x.services?.length || 1}>{x.equipmenName}</td>
                                          <td>{x.services.length > 0 ? x.services[0].serviceType : "-"}</td>
                                          <td rowspan={x.services?.length || 1}>{x.actualQty}</td>
                                          <td>{x.services.length > 0 ? x.services[0].qtyDone : "-"}</td>
                                          <td>{x.services.length > 0 ? x.services[0].serviceDate : "-"}</td>
                                          <td>{x.services.length > 0 ? x.services[0].servicedZone : "-"}</td>
                                          <td>{x.services.length > 0 ? x.services[0].cost : "-"}</td>
                                          <td rowspan={x.services?.length || 1}>{x.totalCost}</td>
                                          <td rowspan={x.services?.length || 1}>{x.totalQtyDone}</td>
                                          <td rowspan={x.services?.length || 1} className={x.jobStatus?.toLowerCase() == "completed" ? "completed" : "not-completed"}>{x.jobStatus}</td>
                                          <td rowspan={x.services?.length || 1}>{Math.round(x.costSaving * 100) / 100 + '%'}</td>
                                        </tr>
                                        {
                                          x.services.length > 1 ?
                                            x.services.map((y, inds) => (

                                              inds != 0 ? <tr>
                                                <td>{y.serviceType}</td>
                                                <td>{y.qtyDone}</td>
                                                <td>{y.serviceDate}</td>
                                                <td>{y.servicedZone}</td>
                                                <td>{y.cost}</td>
                                              </tr> : ""
                                            ))
                                            :
                                            ""
                                        }
                                      </>
                                    )) :
                                      <tr><td colSpan="11" width="100%" className="text-center">{t("CommonText.NoItem")}</td></tr>
                                  }
                                </tbody> */}
                                <tbody>
                                  {shipEquipmentServiceHistoryBudget?.contract
                                    ?.length > 0 ? (
                                    this.groupServicesByType(
                                      shipEquipmentServiceHistoryBudget?.contract
                                    )?.map((x, ind) => (
                                      <>
                                        <tr>
                                          <td
                                            align="center"
                                            rowspan={x.services?.length || 1}
                                            className=""
                                          >
                                            {ind + 1}
                                          </td>
                                          <td
                                            align="center"
                                            rowspan={x.services?.length || 1}
                                          >
                                            {x.equipmenName}
                                          </td>
                                          <td
                                            align="center"
                                            rowspan={
                                              x.availableservices[0].services
                                                .length || 1
                                            }
                                          >
                                            {
                                              x.availableservices[0]
                                                ?.serviceType
                                            }
                                          </td>
                                          <td
                                            align="center"
                                            rowspan={
                                              x.availableservices[0].services
                                                .length || 1
                                            }
                                          >
                                            {x.actualQty}
                                          </td>
                                          <td
                                            align="center"
                                            rowspan={
                                              x.availableservices[0].services
                                                .length || 1
                                            }
                                          >
                                            <OverlayTrigger
                                              placement="top"
                                              delay={{ show: 100, hide: 200 }}
                                              overlay={
                                                x.applicableServices[0]
                                                  ?.jobStatus == "Completed" ? (
                                                  <div></div>
                                                ) : (
                                                  this.renderView(
                                                    x.availableservices[0]
                                                      ?.dueInfo.overDue,
                                                    x.availableservices[0]
                                                      ?.dueInfo.in10Days,
                                                    x.availableservices[0]
                                                      ?.dueInfo.in30Days,
                                                    x.availableservices[0]
                                                      ?.dueInfo.in60Days,
                                                    x.availableservices[0]
                                                      ?.dueInfo.in90Days
                                                  )
                                                )
                                              }
                                            >
                                              <span
                                                className={`${
                                                  x.applicableServices[0]
                                                    ?.jobStatus == "Completed"
                                                    ? ""
                                                    : x.availableservices[0]
                                                        ?.dueInfo.overDue
                                                    ? "font-overdue"
                                                    : x.availableservices[0]
                                                        ?.dueInfo.in10Days
                                                    ? "font-in10days"
                                                    : x.availableservices[0]
                                                        ?.dueInfo.in30Days
                                                    ? "font-in30days"
                                                    : x.availableservices[0]
                                                        ?.dueInfo.in60Days
                                                    ? "font-in60days"
                                                    : x.availableservices[0]
                                                        ?.dueInfo.in90Days
                                                    ? "font-in90days"
                                                    : ""
                                                }`}
                                              >
                                                {
                                                  x.availableservices[0]
                                                    ?.latestServiceDueDate
                                                }
                                              </span>
                                            </OverlayTrigger>
                                          </td>
                                          <td align="center">
                                            {x.services.length > 0
                                              ? x.services[0].serviceDate
                                              : "-"}
                                          </td>
                                          <td align="center">
                                            {x.services.length > 0
                                              ? x.services[0].qtyDone
                                              : "-"}
                                          </td>
                                          <td align="center">
                                            {x.services.length > 0
                                              ? x.services[0].servicedZone
                                              : "-"}
                                          </td>
                                          <td align="center">
                                            {x.services.length > 0
                                              ? x.services[0].cost
                                              : "-"}
                                          </td>
                                          <td
                                            align="center"
                                            rowspan={
                                              x.availableservices[0].services
                                                .length || 1
                                            }
                                          >
                                            {x.applicableServices[0]
                                              ?.totalCost ?? 0}
                                          </td>
                                          <td
                                            align="center"
                                            rowspan={
                                              x.availableservices[0].services
                                                .length || 1
                                            }
                                          >
                                            {x.applicableServices[0]
                                              ?.totalQty ?? 0}
                                          </td>
                                          <td
                                            align={"center"}
                                            rowspan={
                                              x.availableservices[0].services
                                                .length || 1
                                            }
                                            className={
                                              x.applicableServices[0]
                                                ?.jobStatus == "Completed"
                                                ? "completed"
                                                : "not-completed"
                                            }
                                          >
                                            {x.applicableServices[0]?.jobStatus}
                                          </td>
                                          <td
                                            align={"center"}
                                            rowspan={
                                              x.availableservices[0].services
                                                .length || 1
                                            }
                                          >
                                            {Math.round(
                                              x.applicableServices[0]
                                                ?.costSaving * 100
                                            ) /
                                              100 +
                                              "%"}
                                          </td>
                                          {/* <td rowspan={x.services?.length || 1}>{Math.round(x.costSaving * 100) / 100 + '%'}</td> */}
                                        </tr>
                                        {x.services.length > 1 &&
                                          (() => {
                                            let initialavail = 1;
                                            let initialavail1 = 1;
                                            let initialServiceLength =
                                              x.availableservices[0]?.services
                                                ?.length || 0;
                                            let initialServiceLength1 =
                                              x.availableservices[0]?.services
                                                ?.length || 0; // Local variable to track updates

                                            return x.services.map((y, ind) => {
                                              if (ind !== 0) {
                                                const currentRow = (
                                                  <tr key={`service-${ind}`}>
                                                    {/* Map availableservices here */}
                                                    {x.availableservices
                                                      .length > 1 &&
                                                      x.availableservices.map(
                                                        (inner1, i1) => {
                                                          // console.log('initialServiceLength:', initialServiceLength, 'ind:', ind);

                                                          // console.log(x.availableservices);
                                                          // Check condition for rendering the available services correctly
                                                          if (
                                                            i1 !== 0 &&
                                                            ind >=
                                                              initialServiceLength &&
                                                            x.availableservices
                                                              .length > 1
                                                          ) {
                                                            // console.log('i1:', i1, 'initialServiceLength:', initialServiceLength, 'ind:', ind);
                                                            if (
                                                              x
                                                                .availableservices[
                                                                initialavail
                                                              ] !== undefined
                                                            ) {
                                                              const cell = (
                                                                <>
                                                                  <td
                                                                    align="center"
                                                                    key={`availableservice-${ind}-${i1}`}
                                                                    rowspan={
                                                                      x
                                                                        .availableservices[
                                                                        initialavail
                                                                      ].services
                                                                        .length ||
                                                                      1
                                                                    }
                                                                  >
                                                                    {
                                                                      x
                                                                        .availableservices[
                                                                        initialavail
                                                                      ]
                                                                        .serviceType
                                                                    }
                                                                  </td>
                                                                  <td
                                                                    align="center"
                                                                    key={`availableservice-qty-${ind}-${i1}`}
                                                                    rowspan={
                                                                      x
                                                                        .availableservices[
                                                                        initialavail
                                                                      ].services
                                                                        .length ||
                                                                      1
                                                                    }
                                                                  >
                                                                    {
                                                                      x.actualQty
                                                                    }
                                                                  </td>
                                                                  <td
                                                                    align="center"
                                                                    key={`availableservice-due-date-${ind}-${i1}`}
                                                                    rowspan={
                                                                      x
                                                                        .availableservices[
                                                                        initialavail
                                                                      ].services
                                                                        .length ||
                                                                      1
                                                                    }
                                                                  >
                                                                    <OverlayTrigger
                                                                      placement="top"
                                                                      delay={{
                                                                        show: 100,
                                                                        hide: 200,
                                                                      }}
                                                                      overlay={
                                                                        x
                                                                          .applicableServices[
                                                                          initialavail
                                                                        ]
                                                                          ?.jobStatus ==
                                                                        "Completed" ? (
                                                                          <div></div>
                                                                        ) : (
                                                                          this.renderView(
                                                                            x
                                                                              .availableservices[
                                                                              initialavail
                                                                            ]
                                                                              ?.dueInfo
                                                                              .overDue,
                                                                            x
                                                                              .availableservices[
                                                                              initialavail
                                                                            ]
                                                                              ?.dueInfo
                                                                              .in10Days,
                                                                            x
                                                                              .availableservices[
                                                                              initialavail
                                                                            ]
                                                                              ?.dueInfo
                                                                              .in30Days,
                                                                            x
                                                                              .availableservices[
                                                                              initialavail
                                                                            ]
                                                                              ?.dueInfo
                                                                              .in60Days,
                                                                            x
                                                                              .availableservices[
                                                                              initialavail
                                                                            ]
                                                                              ?.dueInfo
                                                                              .in90Days
                                                                          )
                                                                        )
                                                                      }
                                                                    >
                                                                      <span
                                                                        className={`${
                                                                          x
                                                                            .applicableServices[
                                                                            initialavail
                                                                          ]
                                                                            ?.jobStatus ==
                                                                          "Completed"
                                                                            ? ""
                                                                            : x
                                                                                .availableservices[
                                                                                initialavail
                                                                              ]
                                                                                ?.dueInfo
                                                                                .overDue
                                                                            ? "font-overdue"
                                                                            : x
                                                                                .availableservices[
                                                                                initialavail
                                                                              ]
                                                                                ?.dueInfo
                                                                                .in10Days
                                                                            ? "font-in10days"
                                                                            : x
                                                                                .availableservices[
                                                                                initialavail
                                                                              ]
                                                                                ?.dueInfo
                                                                                .in30Days
                                                                            ? "font-in30days"
                                                                            : x
                                                                                .availableservices[
                                                                                initialavail
                                                                              ]
                                                                                ?.dueInfo
                                                                                .in60Days
                                                                            ? "font-in60days"
                                                                            : x
                                                                                .availableservices[
                                                                                initialavail
                                                                              ]
                                                                                ?.dueInfo
                                                                                .in90Days
                                                                            ? "font-in90days"
                                                                            : ""
                                                                        }`}
                                                                      >
                                                                        {
                                                                          x
                                                                            .availableservices[
                                                                            initialavail
                                                                          ]
                                                                            .latestServiceDueDate
                                                                        }
                                                                      </span>
                                                                    </OverlayTrigger>
                                                                  </td>
                                                                </>
                                                              );
                                                              // const cell = (
                                                              //   <>
                                                              //     {inner1.services.map((service, serviceIndex) => (
                                                              //       <>
                                                              //         {serviceIndex !== 0 && ind >= initialServiceLength && (
                                                              //           <>
                                                              //             <td align="center" rowSpan={inner1.services.length || 1}>
                                                              //               {service.serviceType}
                                                              //             </td>
                                                              //             <td align="center" rowSpan={inner1.services.length || 1}>
                                                              //               {x.actualQty}
                                                              //             </td>
                                                              //             <td align="center" rowSpan={inner1.services.length || 1}>
                                                              //               {inner1.latestServiceDueDate}
                                                              //             </td>
                                                              //           </>
                                                              //         )}
                                                              //       </>
                                                              //     ))}
                                                              //   </>
                                                              // );
                                                              initialServiceLength +=
                                                                x
                                                                  .availableservices[
                                                                  initialavail
                                                                ].services
                                                                  .length;
                                                              initialavail += 1;
                                                              // console.log(inner1.services.length + "check");
                                                              return cell;
                                                            }
                                                          }
                                                          return null;
                                                        }
                                                      )}
                                                    {/* Row for service details */}
                                                    <td align="center">
                                                      {y.serviceDate}
                                                    </td>
                                                    <td align="center">
                                                      {y.qtyDone}
                                                    </td>
                                                    {/* <td>{y.serviceDate}</td> */}
                                                    <td align="center">
                                                      {y.servicedZone}
                                                    </td>
                                                    <td align="center">
                                                      {y.cost}
                                                    </td>

                                                    {/* Map applicableServices */}
                                                    {x.availableservices
                                                      .length > 1 &&
                                                      x.availableservices.map(
                                                        (inner, i) => {
                                                          if (
                                                            i !== 0 &&
                                                            ind >=
                                                              initialServiceLength1 &&
                                                            x.availableservices
                                                              .length > 1
                                                          ) {
                                                            if (
                                                              x
                                                                .availableservices[
                                                                initialavail1
                                                              ] !== undefined
                                                            ) {
                                                              const cell1 = (
                                                                <>
                                                                  <td
                                                                    align="center"
                                                                    key={`availableservice-cost-${ind}-${i}`}
                                                                    rowspan={
                                                                      x
                                                                        .availableservices[
                                                                        initialavail1
                                                                      ].services
                                                                        .length ||
                                                                      1
                                                                    }
                                                                  >
                                                                    {x
                                                                      .applicableServices[
                                                                      initialavail1
                                                                    ]
                                                                      ?.totalCost &&
                                                                    x
                                                                      .applicableServices[
                                                                      initialavail1
                                                                    ]
                                                                      ?.totalCost !==
                                                                      0
                                                                      ? x
                                                                          .applicableServices[
                                                                          initialavail1
                                                                        ]
                                                                          ?.totalCost
                                                                      : "0"}
                                                                  </td>
                                                                  <td
                                                                    align="center"
                                                                    key={`availableservice-qty-${ind}-${i}`}
                                                                    rowspan={
                                                                      x
                                                                        .availableservices[
                                                                        initialavail1
                                                                      ].services
                                                                        .length ||
                                                                      1
                                                                    }
                                                                  >
                                                                    {x
                                                                      .applicableServices[
                                                                      initialavail1
                                                                    ]?.totalQty
                                                                      ? x
                                                                          .applicableServices[
                                                                          initialavail1
                                                                        ]
                                                                          ?.totalQty
                                                                      : "0"}
                                                                  </td>
                                                                  <td
                                                                    align={
                                                                      "center"
                                                                    }
                                                                    rowspan={
                                                                      x
                                                                        .availableservices[
                                                                        initialavail1
                                                                      ].services
                                                                        .length ||
                                                                      1
                                                                    }
                                                                    className={
                                                                      x
                                                                        .applicableServices[
                                                                        initialavail1
                                                                      ]
                                                                        ?.jobStatus ==
                                                                      "Completed"
                                                                        ? "completed"
                                                                        : "not-completed"
                                                                    }
                                                                  >
                                                                    {
                                                                      x
                                                                        .applicableServices[
                                                                        initialavail1
                                                                      ]
                                                                        ?.jobStatus
                                                                    }
                                                                  </td>
                                                                  <td
                                                                    align={
                                                                      "center"
                                                                    }
                                                                    rowspan={
                                                                      x
                                                                        .availableservices[
                                                                        initialavail1
                                                                      ].services
                                                                        .length ||
                                                                      1
                                                                    }
                                                                  >
                                                                    {Math.round(
                                                                      x
                                                                        .applicableServices[
                                                                        initialavail1
                                                                      ]
                                                                        ?.costSaving *
                                                                        100
                                                                    ) /
                                                                      100 +
                                                                      "%"}
                                                                  </td>
                                                                </>
                                                              );
                                                              // const cell1 = (
                                                              //   <>
                                                              //     {inner.services.map((service1, serviceIndex1) => (
                                                              //       <>
                                                              //         {serviceIndex1 !== 0 && ind>= initialServiceLength1 && (
                                                              //           <>
                                                              //             <td align="center" key={`availableservice-cost-${ind}-${i}`} rowspan={inner.services.length || 1}>
                                                              //               {x.applicableServices[i]?.totalCost && x.applicableServices[i]?.totalCost !== 0
                                                              //                 ? x.applicableServices[i]?.totalCost
                                                              //                 : '0'}
                                                              //             </td>
                                                              //             <td align="center" key={`availableservice-qty-${ind}-${i}`} rowspan={inner.services.length || 1}>
                                                              //               {x.applicableServices[i]?.totalQty ? x.applicableServices[i]?.totalQty : '0'}
                                                              //             </td>
                                                              //             <td align={"center"} rowspan={inner.services.length || 1} className={x.applicableServices[i]?.jobStatus == "Completed" ? "completed" : "not-completed"}>{x.applicableServices[i]?.jobStatus}</td>
                                                              //             <td align={"center"} rowspan={inner.services.length || 1}>{Math.round(x.applicableServices[i]?.costSaving * 100) / 100 + '%'}</td>
                                                              //           </>
                                                              //         )}
                                                              //       </>
                                                              //     ))}
                                                              //   </>
                                                              // );
                                                              initialServiceLength1 +=
                                                                x
                                                                  .availableservices[
                                                                  initialavail1
                                                                ].services
                                                                  .length;
                                                              initialavail1 += 1;
                                                              return cell1;
                                                            }
                                                          }
                                                          return null;
                                                        }
                                                      )}
                                                  </tr>
                                                );

                                                return currentRow;
                                              }
                                              return null;
                                            });
                                          })()}
                                      </>
                                    ))
                                  ) : (
                                    <tr>
                                      <td
                                        colSpan="11"
                                        width="100%"
                                        className="text-center"
                                      >
                                        {t("CommonText.NoItem")}
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                          <div
                            className="tab-pane fade pb-3"
                            id="addon"
                            role="tabpanel"
                            aria-labelledby="addon-tab"
                          >
                            <div className="equip-type-wrapper min-hei-54">
                              <table
                                className="table service-cost-table table-responsive border-0"
                                style={{
                                  boxShadow:
                                    " rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
                                }}
                              >
                                <thead className="">
                                  <tr>
                                    <th scope="col">
                                      {t("ServiceBudgetHistory.SNo")}
                                    </th>
                                    <th scope="col">
                                      {t("ServiceBudgetHistory.EquipmentName")}
                                    </th>
                                    <th scope="col">
                                      {t("content.Servicetype")}
                                    </th>
                                    <th scope="col">
                                      {t("ServiceBudgetHistory.ActualQty")}
                                    </th>
                                    <th scope="col">
                                      {t("ServiceBudgetHistory.duedate")}
                                    </th>
                                    {/* <th scope="col">Service Due Date</th> */}
                                    <th scope="col">
                                      {t("ServiceBudgetHistory.ServiceDate")}
                                    </th>
                                    <th scope="col">
                                      {t("ServiceBudgetHistory.QtyDone")}
                                    </th>
                                    {/* <th scope="col">{t("ServiceBudgetHistory.ServiceDate")}</th> */}
                                    <th scope="col">
                                      {t("ServiceBudgetHistory.ServicedZone")}
                                    </th>
                                    <th scope="col">
                                      {t("ServiceBudgetHistory.Cost")}
                                    </th>
                                    <th scope="col">
                                      {t("ServiceBudgetHistory.TotalCost")}
                                    </th>
                                    <th scope="col">
                                      {t("ServiceBudgetHistory.TotalQtyDone")}
                                    </th>
                                    <th scope="col">
                                      {t("ServiceBudgetHistory.JobStatus")}
                                    </th>
                                    <th scope="col">
                                      {t("ServiceBudgetHistory.CostSaving")}
                                    </th>
                                  </tr>
                                </thead>
                                {/* <tbody>
                                  {
                                    shipEquipmentServiceHistoryBudget?.addOn?.length > 0 ? this.groupServicesByType(shipEquipmentServiceHistoryBudget?.addOn)?.map((x, ind) => (
                                      <>
                                        <tr>
                                          <td rowspan={x.services?.length || 1} className="leftsix">{ind + 1}</td>
                                          <td rowspan={x.services?.length || 1}>{x.equipmenName}</td>

                                          <td>{x.services.length > 0 ? x.services[0].serviceType : "-"}</td>
                                          <td >{x.actualQty}</td>
                                          <td>{x.services.length > 0 ? x.services[0].qtyDone : "-"}</td>
                                          <td>{x.services.length > 0 ? x.services[0].serviceDate : "-"}</td>
                                          <td>{x.services.length > 0 ? x.services[0].servicedZone : "-"}</td>
                                          <td>{x.services.length > 0 ? x.services[0].cost : "-"}</td>
                                          <td rowspan={x.services?.length || 1}>{x.totalCost}</td>
                                          <td rowspan={x.services?.length || 1}>{x.totalQtyDone}</td>
                                          <td rowspan={x.services?.length || 1} className={x.jobStatus == "Completed" ? "completed" : "not-completed"}>{x.jobStatus}</td>
                                          <td rowspan={x.services?.length || 1}>{Math.round(x.costSaving * 100) / 100 + '%'}</td>
                                        </tr>
                                        {
                                          x.services.length > 1 ?
                                            x.services.map((y, ind) => (
                                              ind != 0 ? <tr>
                                                <td>{y.serviceType}</td>
                                                <td>{x.actualQty}</td>
                                                <td>{y.qtyDone}</td>
                                                <td>{y.serviceDate}</td>
                                                <td>{y.servicedZone}</td>
                                                <td>{y.cost}</td>
                                              </tr> : ""
                                            ))
                                            :
                                            ""
                                        }
                                      </>
                                    )) :
                                      <tr><td colSpan="11" width="100%" className="text-center">{t("CommonText.NoItem")}</td></tr>
                                  }
                                </tbody> */}
                                <tbody>
                                  {shipEquipmentServiceHistoryBudget?.addOn
                                    ?.length > 0 ? (
                                    this.groupServicesByType(
                                      shipEquipmentServiceHistoryBudget?.addOn
                                    )?.map((x, ind) => (
                                      <>
                                        <tr>
                                          <td
                                            align="center"
                                            rowspan={x.services?.length || 1}
                                            className=""
                                          >
                                            {ind + 1}
                                          </td>
                                          <td
                                            align="center"
                                            rowspan={x.services?.length || 1}
                                          >
                                            {x.equipmenName}
                                          </td>

                                          {/* <td >{x.services.length > 0 ? x.services[0].serviceType : "-"}</td> */}
                                          <td
                                            align={"center"}
                                            rowspan={
                                              x.availableservices[0].services
                                                .length || 1
                                            }
                                          >
                                            {
                                              x.availableservices[0]
                                                ?.serviceType
                                            }
                                          </td>
                                          {/* <td rowspan={x.services?.length || 1}>
                                            {x?.availableservices.map((inner, index) => (
                                              <tr align="middle">
                                                <td style={{borderTop:"none",borderBottom:"none"}}  colSpan={inner?.services?.length || 1}>{x.actualQty}</td>
                                              </tr>
                                            ))}
                                          </td> */}
                                          <td
                                            align={"center"}
                                            rowspan={
                                              x.availableservices[0].services
                                                .length || 1
                                            }
                                          >
                                            {x.actualQty}
                                          </td>
                                          <td
                                            align={"center"}
                                            rowspan={
                                              x.availableservices[0].services
                                                .length || 1
                                            }
                                          >
                                            <OverlayTrigger
                                              placement="top"
                                              delay={{ show: 100, hide: 200 }}
                                              overlay={
                                                x.applicableServices[0]
                                                  ?.jobStatus == "Completed" ? (
                                                  <div></div>
                                                ) : (
                                                  this.renderView(
                                                    x.availableservices[0]
                                                      ?.dueInfo.overDue,
                                                    x.availableservices[0]
                                                      ?.dueInfo.in10Days,
                                                    x.availableservices[0]
                                                      ?.dueInfo.in30Days,
                                                    x.availableservices[0]
                                                      ?.dueInfo.in60Days,
                                                    x.availableservices[0]
                                                      ?.dueInfo.in90Days
                                                  )
                                                )
                                              }
                                            >
                                              <span
                                                className={`${
                                                  x.applicableServices[0]
                                                    ?.jobStatus == "Completed"
                                                    ? ""
                                                    : x.availableservices[0]
                                                        ?.dueInfo.overDue
                                                    ? "font-overdue"
                                                    : x.availableservices[0]
                                                        ?.dueInfo.in10Days
                                                    ? "font-in10days"
                                                    : x.availableservices[0]
                                                        ?.dueInfo.in30Days
                                                    ? "font-in30days"
                                                    : x.availableservices[0]
                                                        ?.dueInfo.in60Days
                                                    ? "font-in60days"
                                                    : x.availableservices[0]
                                                        ?.dueInfo.in90Days
                                                    ? "font-in90days"
                                                    : ""
                                                }`}
                                              >
                                                {
                                                  x.availableservices[0]
                                                    ?.latestServiceDueDate
                                                }
                                              </span>
                                            </OverlayTrigger>
                                          </td>
                                          <td align="center">
                                            {x.services.length > 0
                                              ? x.services[0].serviceDate
                                              : "-"}
                                          </td>
                                          <td align="center">
                                            {x.services.length > 0
                                              ? x.services[0].qtyDone
                                              : "-"}
                                          </td>
                                          {/* <td>{x.services.length > 0 ? x.services[0].serviceDate : "-"}</td> */}
                                          <td align="center">
                                            {x.services.length > 0
                                              ? x.services[0].servicedZone
                                              : "-"}
                                          </td>
                                          <td align="center">
                                            {x.services.length > 0
                                              ? x.services[0].cost
                                              : "-"}
                                          </td>
                                          {/* <td rowspan={x.services?.length || 1}>{x.totalCost}</td> */}
                                          <td
                                            align={"center"}
                                            rowspan={
                                              x.availableservices[0].services
                                                .length || 1
                                            }
                                          >
                                            {x.applicableServices[0]
                                              ?.totalCost ?? 0}
                                          </td>
                                          <td
                                            align={"center"}
                                            rowspan={
                                              x.availableservices[0].services
                                                .length || 1
                                            }
                                          >
                                            {x.applicableServices[0]
                                              ?.totalQty ?? 0}
                                          </td>
                                          {/* <td rowspan={x.services?.length || 1}>{x.totalQtyDone}</td> */}
                                          {/* <td rowspan={x.services?.length || 1} className={x.jobStatus == "Completed" ? "completed" : "not-completed"}>{x.jobStatus}</td> */}
                                          <td
                                            align={"center"}
                                            rowspan={
                                              x.availableservices[0].services
                                                .length || 1
                                            }
                                            className={
                                              x.applicableServices[0]
                                                ?.jobStatus == "Completed"
                                                ? "completed"
                                                : "not-completed"
                                            }
                                          >
                                            {x.applicableServices[0]?.jobStatus}
                                          </td>
                                          <td
                                            align={"center"}
                                            rowspan={
                                              x.availableservices[0].services
                                                .length || 1
                                            }
                                          >
                                            {Math.round(
                                              x.applicableServices[0]
                                                ?.costSaving * 100
                                            ) /
                                              100 +
                                              "%"}
                                          </td>
                                          {/* <td rowspan={x.services?.length || 1}>{Math.round(x.costSaving * 100) / 100 + '%'}</td> */}
                                        </tr>
                                        {x.services.length > 1 &&
                                          (() => {
                                            let initialavail = 1;
                                            let initialavail1 = 1;
                                            let initialServiceLength =
                                              x.availableservices[0]?.services
                                                ?.length || 0;
                                            let initialServiceLength1 =
                                              x.availableservices[0]?.services
                                                ?.length || 0; // Local variable to track updates

                                            return x.services.map((y, ind) => {
                                              if (ind !== 0) {
                                                const currentRow = (
                                                  <tr key={`service-${ind}`}>
                                                    {/* Map availableservices here */}
                                                    {x.availableservices
                                                      .length > 1 &&
                                                      x.availableservices.map(
                                                        (inner1, i1) => {
                                                          // console.log('initialServiceLength:', initialServiceLength, 'ind:', ind);

                                                          // console.log(x.availableservices);
                                                          // Check condition for rendering the available services correctly
                                                          if (
                                                            i1 !== 0 &&
                                                            ind >=
                                                              initialServiceLength &&
                                                            x.availableservices
                                                              .length > 1
                                                          ) {
                                                            // console.log('i1:', i1, 'initialServiceLength:', initialServiceLength, 'ind:', ind);
                                                            if (
                                                              x
                                                                .availableservices[
                                                                initialavail
                                                              ] !== undefined
                                                            ) {
                                                              const cell = (
                                                                <>
                                                                  <td
                                                                    align="center"
                                                                    key={`availableservice-${ind}-${i1}`}
                                                                    rowspan={
                                                                      x
                                                                        .availableservices[
                                                                        initialavail
                                                                      ].services
                                                                        .length ||
                                                                      1
                                                                    }
                                                                  >
                                                                    {
                                                                      x
                                                                        .availableservices[
                                                                        initialavail
                                                                      ]
                                                                        .serviceType
                                                                    }
                                                                  </td>
                                                                  <td
                                                                    align="center"
                                                                    key={`availableservice-qty-${ind}-${i1}`}
                                                                    rowspan={
                                                                      x
                                                                        .availableservices[
                                                                        initialavail
                                                                      ].services
                                                                        .length ||
                                                                      1
                                                                    }
                                                                  >
                                                                    {
                                                                      x.actualQty
                                                                    }
                                                                  </td>
                                                                  <td
                                                                    align="center"
                                                                    key={`availableservice-due-date-${ind}-${i1}`}
                                                                    rowspan={
                                                                      x
                                                                        .availableservices[
                                                                        initialavail
                                                                      ].services
                                                                        .length ||
                                                                      1
                                                                    }
                                                                  >
                                                                    <OverlayTrigger
                                                                      placement="top"
                                                                      delay={{
                                                                        show: 100,
                                                                        hide: 200,
                                                                      }}
                                                                      overlay={
                                                                        x
                                                                          .applicableServices[
                                                                          initialavail
                                                                        ]
                                                                          ?.jobStatus ==
                                                                        "Completed" ? (
                                                                          <div></div>
                                                                        ) : (
                                                                          this.renderView(
                                                                            x
                                                                              .availableservices[
                                                                              initialavail
                                                                            ]
                                                                              ?.dueInfo
                                                                              .overDue,
                                                                            x
                                                                              .availableservices[
                                                                              initialavail
                                                                            ]
                                                                              ?.dueInfo
                                                                              .in10Days,
                                                                            x
                                                                              .availableservices[
                                                                              initialavail
                                                                            ]
                                                                              ?.dueInfo
                                                                              .in30Days,
                                                                            x
                                                                              .availableservices[
                                                                              initialavail
                                                                            ]
                                                                              ?.dueInfo
                                                                              .in60Days,
                                                                            x
                                                                              .availableservices[
                                                                              initialavail
                                                                            ]
                                                                              ?.dueInfo
                                                                              .in90Days
                                                                          )
                                                                        )
                                                                      }
                                                                    >
                                                                      <span
                                                                        className={`${
                                                                          x
                                                                            .applicableServices[
                                                                            initialavail
                                                                          ]
                                                                            ?.jobStatus ==
                                                                          "Completed"
                                                                            ? ""
                                                                            : x
                                                                                .availableservices[
                                                                                initialavail
                                                                              ]
                                                                                ?.dueInfo
                                                                                .overDue
                                                                            ? "font-overdue"
                                                                            : x
                                                                                .availableservices[
                                                                                initialavail
                                                                              ]
                                                                                ?.dueInfo
                                                                                .in10Days
                                                                            ? "font-in10days"
                                                                            : x
                                                                                .availableservices[
                                                                                initialavail
                                                                              ]
                                                                                ?.dueInfo
                                                                                .in30Days
                                                                            ? "font-in30days"
                                                                            : x
                                                                                .availableservices[
                                                                                initialavail
                                                                              ]
                                                                                ?.dueInfo
                                                                                .in60Days
                                                                            ? "font-in60days"
                                                                            : x
                                                                                .availableservices[
                                                                                initialavail
                                                                              ]
                                                                                ?.dueInfo
                                                                                .in90Days
                                                                            ? "font-in90days"
                                                                            : ""
                                                                        }`}
                                                                      >
                                                                        {
                                                                          x
                                                                            .availableservices[
                                                                            initialavail
                                                                          ]
                                                                            .latestServiceDueDate
                                                                        }
                                                                      </span>
                                                                    </OverlayTrigger>
                                                                  </td>
                                                                </>
                                                              );
                                                              initialServiceLength +=
                                                                x
                                                                  .availableservices[
                                                                  initialavail
                                                                ].services
                                                                  .length;
                                                              initialavail += 1;
                                                              // console.log(inner1.services.length + "check");
                                                              return cell;
                                                            }
                                                            // Update service length correctly
                                                          }
                                                          return null;
                                                        }
                                                      )}
                                                    {/* Row for service details */}
                                                    <td align="center">
                                                      {y.serviceDate}
                                                    </td>
                                                    <td align="center">
                                                      {y.qtyDone}
                                                    </td>
                                                    {/* <td>{y.serviceDate}</td> */}
                                                    <td align="center">
                                                      {y.servicedZone}
                                                    </td>
                                                    <td align="center">
                                                      {y.cost}
                                                    </td>

                                                    {/* Map applicableServices */}
                                                    {x.availableservices
                                                      .length > 1 &&
                                                      x.availableservices.map(
                                                        (inner, i) => {
                                                          if (
                                                            i !== 0 &&
                                                            ind >=
                                                              initialServiceLength1 &&
                                                            x.availableservices
                                                              .length > 1
                                                          ) {
                                                            if (
                                                              x
                                                                .availableservices[
                                                                initialavail1
                                                              ] !== undefined
                                                            ) {
                                                              const cell1 = (
                                                                <>
                                                                  <td
                                                                    align="center"
                                                                    key={`availableservice-cost-${ind}-${i}`}
                                                                    rowspan={
                                                                      x
                                                                        .availableservices[
                                                                        initialavail1
                                                                      ].services
                                                                        .length ||
                                                                      1
                                                                    }
                                                                  >
                                                                    {x
                                                                      .applicableServices[
                                                                      initialavail1
                                                                    ]
                                                                      ?.totalCost &&
                                                                    x
                                                                      .applicableServices[
                                                                      initialavail1
                                                                    ]
                                                                      ?.totalCost !==
                                                                      0
                                                                      ? x
                                                                          .applicableServices[
                                                                          initialavail1
                                                                        ]
                                                                          ?.totalCost
                                                                      : "0"}
                                                                  </td>
                                                                  <td
                                                                    align="center"
                                                                    key={`availableservice-qty-${ind}-${i}`}
                                                                    rowspan={
                                                                      x
                                                                        .availableservices[
                                                                        initialavail1
                                                                      ].services
                                                                        .length ||
                                                                      1
                                                                    }
                                                                  >
                                                                    {x
                                                                      .applicableServices[
                                                                      initialavail1
                                                                    ]?.totalQty
                                                                      ? x
                                                                          .applicableServices[
                                                                          initialavail1
                                                                        ]
                                                                          ?.totalQty
                                                                      : "0"}
                                                                  </td>
                                                                  <td
                                                                    align={
                                                                      "center"
                                                                    }
                                                                    rowspan={
                                                                      x
                                                                        .availableservices[
                                                                        initialavail1
                                                                      ].services
                                                                        .length ||
                                                                      1
                                                                    }
                                                                    className={
                                                                      x
                                                                        .applicableServices[
                                                                        initialavail1
                                                                      ]
                                                                        ?.jobStatus ==
                                                                      "Completed"
                                                                        ? "completed"
                                                                        : "not-completed"
                                                                    }
                                                                  >
                                                                    {
                                                                      x
                                                                        .applicableServices[
                                                                        initialavail1
                                                                      ]
                                                                        ?.jobStatus
                                                                    }
                                                                  </td>
                                                                  <td
                                                                    align={
                                                                      "center"
                                                                    }
                                                                    rowspan={
                                                                      x
                                                                        .availableservices[
                                                                        initialavail1
                                                                      ].services
                                                                        .length ||
                                                                      1
                                                                    }
                                                                  >
                                                                    {Math.round(
                                                                      x
                                                                        .applicableServices[
                                                                        initialavail1
                                                                      ]
                                                                        ?.costSaving *
                                                                        100
                                                                    ) /
                                                                      100 +
                                                                      "%"}
                                                                  </td>
                                                                </>
                                                              );
                                                              initialServiceLength1 +=
                                                                x
                                                                  .availableservices[
                                                                  initialavail1
                                                                ].services
                                                                  .length;
                                                              initialavail1 += 1;
                                                              return cell1;
                                                            }
                                                          }
                                                          return null;
                                                        }
                                                      )}
                                                  </tr>
                                                );

                                                return currentRow;
                                              }
                                              return null;
                                            });
                                          })()}
                                      </>
                                    ))
                                  ) : (
                                    <tr>
                                      <td
                                        colSpan="11"
                                        width="100%"
                                        className="text-center"
                                      >
                                        {t("CommonText.NoItem")}
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                          <div
                            className="tab-pane fade pb-3"
                            id="contact1"
                            role="tabpanel"
                            aria-labelledby="contact1-tab"
                          >
                            <div className="equip-type-wrapper min-hei-54">
                              <table
                                className="table service-cost-table table-responsive border-0"
                                style={{
                                  boxShadow:
                                    " rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
                                }}
                              >
                                <thead className="">
                                  <tr>
                                    <th scope="col">
                                      {t("ServiceBudgetHistory.SNo")}
                                    </th>
                                    <th scope="col">
                                      {t("ServiceBudgetHistory.EquipmentName")}
                                    </th>
                                    <th scope="col">
                                      {t("ShipEquipmentStatusScreen.Make")}
                                    </th>
                                    <th scope="col">
                                      {t("ShipEquipmentStatusScreen.Model")}
                                    </th>
                                    <th scope="col">
                                      {t("ShipDetailsScreen.ServiceDate")}
                                    </th>
                                    <th scope="col">
                                      {t("ServiceBudgetHistory.duedate")}
                                    </th>
                                    <th scope="col">
                                      {t("ShipEquipmentStatusScreen.Type")}
                                    </th>
                                    <th scope="col">
                                      {t("TopPaneContent.Port")}
                                    </th>
                                    <th scope="col">
                                      {t("EquipmentServiceTypes.Country")}
                                    </th>
                                    <th scope="col">
                                      {t("TopPaneContent.Zone")}
                                    </th>
                                    <th scope="col">
                                      {t("ComplianceandBudgetScreen.Qty")}
                                    </th>
                                    <th scope="col">
                                      {t("ServiceBudgetHistory.MMPLAmount")}
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {shipEquipmentServiceHistoryBudget?.adHoc
                                    ?.length > 0 ? (
                                    shipEquipmentServiceHistoryBudget?.adHoc.map(
                                      (x, ind) => (
                                        <tr>
                                          <td align="center">{ind + 1}</td>
                                          <td align="center">
                                            {x.equipmentName && x.equipmentName}
                                          </td>
                                          <td align="center">
                                            {x.make && x.make}
                                          </td>
                                          <td align="center">
                                            {x.model && x.model}
                                          </td>
                                          <td align="center">
                                            {x.serviceDate && x.serviceDate}
                                          </td>
                                          <td align="center">
                                            <OverlayTrigger
                                              placement="top"
                                              delay={{ show: 100, hide: 200 }}
                                              overlay={this.renderView(
                                                x.overDue,
                                                x.in10Days,
                                                x.in30Days,
                                                x.in60Days,
                                                x.in90Days
                                              )}
                                            >
                                              <span
                                                className={`${
                                                  x.overDue
                                                    ? "font-overdue"
                                                    : x.in10Days
                                                    ? "font-in10days"
                                                    : x.in30Days
                                                    ? "font-in30days"
                                                    : x.in60Days
                                                    ? "font-in60days"
                                                    : x.in90Days
                                                    ? "font-in90days"
                                                    : ""
                                                }`}
                                              >
                                                {x.nextDueDate && x.nextDueDate}
                                              </span>
                                            </OverlayTrigger>
                                          </td>
                                          <td align="center">
                                            {x.type && x.type}
                                          </td>
                                          <td align="center">
                                            {x.port && x.port}
                                          </td>
                                          <td align="center">
                                            {x.country && x.country}
                                          </td>
                                          <td align="center">
                                            {x.zone && x.zone}
                                          </td>
                                          <td align="center">
                                            {x.qty && x.qty}
                                          </td>
                                          <td align="center">
                                            {x.mmplPrice && x.mmplPrice}
                                          </td>
                                        </tr>
                                      )
                                    )
                                  ) : (
                                    <tr>
                                      <td
                                        colSpan="11"
                                        width="100%"
                                        className="text-center"
                                      >
                                        {t("CommonText.NoItem")}
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                          <div
                            className="tab-pane fade pb-3"
                            id="shipstaff"
                            role="tabpanel"
                            aria-labelledby="shipstaff-tab"
                          >
                            <div className="equip-type-wrapper min-hei-54">
                              <table
                                className="table service-cost-table table-responsive border-0 w-100"
                                style={{
                                  boxShadow:
                                    " rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
                                }}
                              >
                                <thead>
                                  <tr>
                                    <th align="left" width="5%" scope="col">
                                      {t("ServiceBudgetHistory.SNo")}
                                    </th>
                                    <th
                                      className="leftAlign"
                                      align="left"
                                      width="55%"
                                      scope="col"
                                    >
                                      {t("ServiceBudgetHistory.EquipmentName")}
                                    </th>
                                    <th
                                      className="leftAlign"
                                      align="left"
                                      width="20%"
                                      scope="col"
                                    >
                                      {t("ShipEquipmentStatusScreen.Quantity")}
                                    </th>
                                    <th
                                      className="leftAlign"
                                      align="left"
                                      width="20%"
                                      scope="col"
                                    >
                                      {t("ServiceBudgetHistory.ServiceDate")}
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {shipEquipmentServiceHistoryBudget?.shipStaff
                                    ?.length > 0 ? (
                                    shipEquipmentServiceHistoryBudget?.shipStaff.map(
                                      (x, ind) => (
                                        <tr>
                                          <td align="center" width="5%">
                                            {ind + 1}
                                          </td>
                                          <td width="55%">
                                            {x.equipmentName && x.equipmentName}
                                          </td>
                                          <td width="20%">
                                            {x.quantity && x.quantity}
                                          </td>
                                          <td width="20%">
                                            {x.serviceDate && x.serviceDate}
                                          </td>
                                        </tr>
                                      )
                                    )
                                  ) : (
                                    <tr>
                                      <td colSpan="4" className="text-center">
                                        {t("CommonText.NoItem")}
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="tab-pane fade"
                      id="profile"
                      role="tabpanel"
                      aria-labelledby="profile-tab"
                      style={{ boxShadow: "none" }}
                    >
                      <div className="equip-type-wrapper min-hei-54">
                        <h5 className="m-0 overall-head mt-2">
                          {t("ServiceBudgetHistory.ContractsBudget")}
                        </h5>
                        <div className="row mt-3">
                          <div className="col-md-6 ">
                            <table className="table service-cost-table border-0 tab-sha-bor">
                              <thead className="">
                                <tr>
                                  <th scope="col">FZM</th>
                                  {shipEquipmentServiceBudget?.fzm?.length >
                                    0 &&
                                    shipEquipmentServiceBudget?.fzm?.map(
                                      (item) => (
                                        <th
                                          className={
                                            this.state.currentPlan == item?.zone
                                              ? "plan-selector"
                                              : ""
                                          }
                                          scope="col"
                                        >
                                          {item?.zone}
                                        </th>
                                      )
                                    )}
                                  {/* {
                                    this.state.zoneLookup.map(x => {
                                      return <th className={this.state.currentPlan == x.value ? "plan-selector" : ""} scope="col">{x.value}</th>;
                                    })
                                  } */}
                                </tr>
                              </thead>
                              <tbody>
                                {this.state.timeLine?.map((item) => (
                                  <tr>
                                    <td align="center">{item.text}</td>
                                    {shipEquipmentServiceBudget?.fzm?.length >
                                      0 &&
                                      shipEquipmentServiceBudget?.fzm?.map(
                                        (itemData) => (
                                          <td
                                            className={
                                              itemData.isSelected == true
                                                ? "plan-selector"
                                                : ""
                                            }
                                            align="center"
                                            scope="col"
                                          >
                                            {(
                                              itemData?.cost / item.div
                                            ).toFixed(2)}
                                          </td>
                                        )
                                      )}
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                          <div className="col-md-6 pl-md-0">
                            <table className="table service-cost-table border-0 tab-sha-bor">
                              <thead className="">
                                <tr>
                                  <th scope="col">IFS</th>
                                  {this.state.budgetDataIFS?.map((item) => (
                                    <th
                                      className={
                                        this.state.currentPlan == item?.zone
                                          ? "plan-selector"
                                          : ""
                                      }
                                      scope="col"
                                    >
                                      {item?.text}
                                    </th>
                                  ))}
                                  {/* {
                                    this.state.budgetIFS &&
                                    Object.keys(this.state.budgetIFS)?.map(x => {
                                      return <th className={this.state.currentPlan == x ? "plan-selector" : ""} scope="col">{x}</th>
                                    })
                                  } */}
                                </tr>
                              </thead>
                              <tbody>
                                {this.state.timeLine.map((x) => {
                                  // className="plan-selector"
                                  return (
                                    <tr>
                                      <td align="center">{x.text}</td>
                                      <td
                                        align="center"
                                        className={
                                          shipEquipmentServiceBudget?.ifs
                                            ?.isBasicPlan == true
                                            ? "plan-selector"
                                            : ""
                                        }
                                      >
                                        {(
                                          shipEquipmentServiceBudget?.ifs
                                            ?.basic / x.div
                                        )?.toFixed(2)}
                                      </td>
                                      <td
                                        align="center"
                                        className={
                                          shipEquipmentServiceBudget?.ifs
                                            ?.isStdPlan == true
                                            ? "plan-selector"
                                            : ""
                                        }
                                      >
                                        {(
                                          shipEquipmentServiceBudget?.ifs?.std /
                                          x.div
                                        )?.toFixed(2)}
                                      </td>
                                      <td
                                        align="center"
                                        className={
                                          shipEquipmentServiceBudget?.ifs
                                            ?.isPremiumPlan == true
                                            ? "plan-selector"
                                            : ""
                                        }
                                      >
                                        {(
                                          shipEquipmentServiceBudget?.ifs
                                            ?.premium / x.div
                                        )?.toFixed(2)}
                                      </td>
                                      {/* {
                                        this.state.budgetIFS && Object.keys(this.state.budgetIFS)?.map(plan => {
                                          return <td className={this.state.currentPlan == plan ? "plan-selector" : ""}>{this.state.budgetIFS[plan] ? this.state.budgetIFS[plan][x.text].toFixed(2) : ""}</td>; /* className="plan-selector"
                                        })
                                      } */}
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="tab-pane fade"
                      id="report"
                      role="tabpanel"
                      aria-labelledby="report-tab"
                    >
                      <div className="equip-type-wrapper">
                        <div className="row mt-2">
                          <div className="col-lg-12">
                            <div className="card MM-card-header">
                              <div className="card-body">
                                <h5 className="card-title ml-2 mt-2">
                                  {t(
                                    "ServiceBudgetHistory.FleetManagerTechnicalSuperintendentReport"
                                  )}
                                </h5>
                              </div>
                            </div>
                            <div className="search-filter-box">
                              <div className="row">
                                <div className="col-lg-4">
                                  <label
                                    className="form-label"
                                    style={{ color: "#000" }}
                                  >
                                    {t("ShipManagementContent.FleetManager")}
                                  </label>
                                  <br></br>
                                  <select
                                    className="form-control"
                                    name="fleetmanager"
                                    value={this.state.fleetmanager}
                                    onChange={(e) =>
                                      this.handleCompanyInputChange(
                                        e,
                                        "fleetmanager"
                                      )
                                    }
                                  >
                                    <option value="">
                                      {t(
                                        "ShipManagementContent.SelectFleetManager"
                                      )}
                                    </option>
                                    {shipUsersReportOptions &&
                                    shipUsersReportOptions?.fleetManagers ? (
                                      shipUsersReportOptions?.fleetManagers.map(
                                        (item) => (
                                          <option value={item.email}>
                                            {item.email}
                                          </option>
                                        )
                                      )
                                    ) : (
                                      <option value=""></option>
                                    )}
                                  </select>
                                </div>
                                <div className="col-lg-4">
                                  <label
                                    className="form-label"
                                    style={{ color: "#000" }}
                                  >
                                    {t(
                                      "ShipManagementContent.TechnicalSuperintendent"
                                    )}
                                  </label>
                                  <br></br>
                                  <select
                                    className="form-control"
                                    name="superintendent"
                                    value={this.state.superintendent}
                                    onChange={(e) =>
                                      this.handleCompanyInputChange(
                                        e,
                                        "superintendent"
                                      )
                                    }
                                  >
                                    <option value="">
                                      {t(
                                        "ShipManagementContent.SelectTechnicalSuperintendent"
                                      )}
                                    </option>
                                    {shipUsersReportOptions &&
                                    shipUsersReportOptions?.techSuperintendent ? (
                                      shipUsersReportOptions?.techSuperintendent.map(
                                        (item) => (
                                          <option value={item.email}>
                                            {item.email}
                                          </option>
                                        )
                                      )
                                    ) : (
                                      <option value=""></option>
                                    )}
                                  </select>
                                </div>
                              </div>
                            </div>
                            <div className="pb-4 pl-4 pr-4">
                              <div
                                className="search-btn-col"
                                style={{ textAlign: "end" }}
                              >
                                <button
                                  className="btn btn-primary text-uppercase txtside-btn txtht-btn blue ml-3"
                                  type="submit"
                                  onClick={() => this.exportReport()}
                                >
                                  {t("ComplianceandBudgetScreen.ExportPDF")}
                                </button>
                                <button
                                  className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                                  type="button"
                                  onClick={() => this.clearFields()}
                                >
                                  {t("content.Clear")}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  onPaginatorChange(event) {
    this.setState({
      first: event.first,
    });
    const { setUpdatedState } = this.props;
    setUpdatedState(event.page + 1, 2);
  }
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

function mapStateToProps(state) {
  return {
    shipEquipmentServiceHistoryBudget:
      state.ShipEquipmentReducer.shipEquipmentServiceHistoryBudget,
    shipEquipmentServiceBudget:
      state.ShipEquipmentReducer.shipEquipmentServiceBudget,
    shipUsersReportOptions: state.ShipEquipmentReducer.shipUsersReportOptions,
    ContractDetail: state.ContractMgmtReducer.ContractDetail,
  };
}
export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(ServiceBudgetHistory)
);
